"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcYield = exports.getPriceRangeFromPeriod = exports.getPriceRangeFromDates = exports.getPriceRange = exports.PERIOD = exports.fetchAndParsePricesCsv = exports.parsePriceRecordsFromCSV = exports.DATA_SOURCE = void 0;
const fetch_ponyfill_1 = __importDefault(require("fetch-ponyfill"));
const stream_1 = require("stream");
const csv_parse_1 = require("csv-parse");
const { fetch } = (0, fetch_ponyfill_1.default)();
const DATA_SOURCE_BASE = 'https://raw.githubusercontent.com/glitchful-dev/sol-stake-pool-apy/master/db/';
exports.DATA_SOURCE = {
    JITO_CSV: `${DATA_SOURCE_BASE}jito.csv`,
    LAINE_CSV: `${DATA_SOURCE_BASE}laine.csv`,
    COGENT_CSV: `${DATA_SOURCE_BASE}cogent.csv`,
    DAOPOOL_CSV: `${DATA_SOURCE_BASE}daopool.csv`,
    EVERSTAKE_CSV: `${DATA_SOURCE_BASE}everstake.csv`,
    INF_CSV: `${DATA_SOURCE_BASE}socean.csv`,
    JPOOL_CSV: `${DATA_SOURCE_BASE}jpool.csv`,
    SOLBLAZE_CSV: `${DATA_SOURCE_BASE}solblaze.csv`,
    LST_CSV: `${DATA_SOURCE_BASE}lst.csv`,
    LIDO_CSV: `${DATA_SOURCE_BASE}lido.csv`,
    MARINADE_CSV: `${DATA_SOURCE_BASE}marinade.csv`,
    EDGEVANA_CSV: `${DATA_SOURCE_BASE}edgevana.csv`,
    HUB_CSV: `${DATA_SOURCE_BASE}hub.csv`,
    PWRSOL_CSV: `${DATA_SOURCE_BASE}pwrsol.csv`,
    PICOSOL_CSV: `${DATA_SOURCE_BASE}picosol.csv`,
};
const DEFAULT_EPOCHS = 10;
const parsePriceRecordsFromCSV = async (csv) => {
    const csvParser = (0, csv_parse_1.parse)({ delimiter: ',', columns: true });
    const records = [];
    for await (const row of csv.pipe(csvParser)) {
        const { timestamp, epoch, price } = row;
        if (!timestamp || !epoch || !price) {
            throw new Error('Columns "timestamp", "epoch", "price" must be present!');
        }
        const record = {
            timestamp: Math.round(new Date(timestamp).getTime() / 1e3),
            epoch: Number(epoch),
            price: Number(price),
        };
        if (isNaN(record.timestamp)) {
            throw new Error('Timestamp must be a... timestamp!');
        }
        if (isNaN(record.epoch)) {
            throw new Error('Epoch must be a number!');
        }
        if (isNaN(record.price)) {
            throw new Error('Price must be a number!');
        }
        records.push(record);
    }
    return records;
};
exports.parsePriceRecordsFromCSV = parsePriceRecordsFromCSV;
const fetchAndParsePricesCsv = async (url) => {
    const csvResponse = await fetch(url);
    const csvContents = await csvResponse.text();
    const prices = await (0, exports.parsePriceRecordsFromCSV)(stream_1.Readable.from([csvContents]));
    return prices;
};
exports.fetchAndParsePricesCsv = fetchAndParsePricesCsv;
var PERIOD;
(function (PERIOD) {
    PERIOD[PERIOD["DAYS_7"] = 604800] = "DAYS_7";
    PERIOD[PERIOD["DAYS_14"] = 1209600] = "DAYS_14";
    PERIOD[PERIOD["DAYS_30"] = 2592000] = "DAYS_30";
    PERIOD[PERIOD["DAYS_90"] = 7776000] = "DAYS_90";
    PERIOD[PERIOD["DAYS_365"] = 31536000] = "DAYS_365";
})(PERIOD = exports.PERIOD || (exports.PERIOD = {}));
const getPriceRange = (priceRecords, startTimestamp, endTimestamp) => {
    priceRecords.sort((a, b) => b.timestamp - a.timestamp);
    let earliestRecord = null;
    let latestRecord = null;
    for (const record of priceRecords) {
        if (record.timestamp >= startTimestamp) {
            earliestRecord = record;
        }
        if (!latestRecord && record.timestamp <= endTimestamp) {
            latestRecord = record;
        }
        if (record.timestamp < startTimestamp) {
            break;
        }
    }
    if (!earliestRecord || !latestRecord) {
        return null;
    }
    if (earliestRecord.timestamp >= latestRecord.timestamp) {
        return null;
    }
    return {
        startPrice: earliestRecord.price,
        endPrice: latestRecord.price,
        startTimestamp: earliestRecord.timestamp,
        endTimestamp: latestRecord.timestamp,
        startEpoch: earliestRecord.epoch,
        endEpoch: latestRecord.epoch,
    };
};
exports.getPriceRange = getPriceRange;
const getPriceRangeFromDates = (priceRecords, start, end) => (0, exports.getPriceRange)(priceRecords, Math.round(start.getTime() / 1e3), Math.round(end.getTime() / 1e3));
exports.getPriceRangeFromDates = getPriceRangeFromDates;
const getPriceRangeFromPeriod = (priceRecords, periodSeconds = PERIOD.DAYS_30, end = new Date()) => (0, exports.getPriceRangeFromDates)(priceRecords, new Date(end.getTime() - periodSeconds * 1e3), end);
exports.getPriceRangeFromPeriod = getPriceRangeFromPeriod;
const calcYield = (priceRange) => {
    if (priceRange.startPrice <= 0 || priceRange.endPrice <= 0) {
        throw new Error('Prices must be positive numbers!');
    }
    const deltaSeconds = priceRange.endTimestamp - priceRange.startTimestamp;
    if (deltaSeconds <= 0) {
        throw new Error('Start timestamp must be before end timestamp!');
    }
    const periodYield = priceRange.endPrice / priceRange.startPrice;
    const epochsPerPeriod = priceRange.endEpoch - priceRange.startEpoch;
    if (deltaSeconds <= 0) {
        throw new Error('At least 1 epoch must be in the range!');
    }
    const averageEpochDuration = deltaSeconds / epochsPerPeriod;
    const epochsPerYear = 31557600 /* SECONDS_PER.YEAR */ / averageEpochDuration;
    const periodsPerYear = 31557600 /* SECONDS_PER.YEAR */ / deltaSeconds;
    const averageEpochRate = periodYield ** (1 / epochsPerPeriod) - 1;
    const apy = (periodYield ** periodsPerYear) - 1;
    const apr = averageEpochRate * epochsPerYear;
    return {
        apy,
        apr,
    };
};
exports.calcYield = calcYield;
//# sourceMappingURL=index.js.map